import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import legal from '../legal';

// Public Terms of Service and Privacy Policy pages (no sign-in needed), rendered
// from src/legal.json so the site, the sign-up checkbox and the Word copies given
// to customers always show the same text and version.

const styles = {
  page: { minHeight: '100vh', backgroundColor: '#0f0f1a', padding: '40px 20px' },
  sheet: {
    maxWidth: '820px', margin: '0 auto', backgroundColor: '#ffffff', borderRadius: '12px',
    padding: '48px 56px', color: '#222222', fontSize: '15px', lineHeight: 1.6,
  },
  brand: { color: '#e94560', fontSize: '20px', fontWeight: 'bold', letterSpacing: '2px' },
  sub: { color: '#666', fontSize: '13px', marginBottom: '28px' },
  title: { color: '#16213e', fontSize: '30px', fontWeight: 'bold', marginBottom: '6px' },
  version: { color: '#666', fontSize: '13px', marginBottom: '28px' },
  intro: { marginBottom: '24px' },
  heading: { color: '#16213e', fontSize: '18px', fontWeight: 'bold', marginTop: '28px', marginBottom: '8px' },
  para: { marginBottom: '10px' },
  navRow: { display: 'flex', gap: '16px', marginTop: '36px', paddingTop: '20px', borderTop: '1px solid #ddd', fontSize: '14px' },
  link: { color: '#0f3460', fontWeight: 'bold' },
};

export function LegalDocument({ doc }) {
  return (
    <div style={styles.page}>
      <div style={styles.sheet}>
        <div style={styles.brand}>EZ PACE</div>
        <div style={styles.sub}>Time Motion System</div>
        <div style={styles.title}>{doc.title}</div>
        <div style={styles.version}>Version {legal.version} · {legal.company}</div>
        <div style={styles.intro}>{doc.intro}</div>
        {doc.sections.map(s => (
          <div key={s.heading}>
            <div style={styles.heading}>{s.heading}</div>
            {s.paragraphs.map((t, i) => <div key={i} style={styles.para}>{t}</div>)}
          </div>
        ))}
        <div style={styles.navRow}>
          <Link to="/terms" style={styles.link}>Terms of Service</Link>
          <Link to="/privacy" style={styles.link}>Privacy Policy</Link>
          <Link to="/login" style={styles.link}>Sign in</Link>
        </div>
      </div>
    </div>
  );
}

export default function Legal() {
  const { pathname } = useLocation();
  return <LegalDocument doc={pathname.includes('privacy') ? legal.privacy : legal.terms} />;
}
